import type { Security } from '@talos/kyoko';
import { compact } from 'lodash-es';

export function getMultilegLegMarketDetails({
  dataSecurity,
  legIndex,
}: {
  dataSecurity: Security;
  legIndex: number | undefined;
}) {
  if (legIndex == null) {
    return [];
  }

  return dataSecurity.MultilegDetails?.Legs?.at(legIndex)?.Markets ?? [];
}

export function getMultilegLegMarketAccounts(params: { dataSecurity: Security; legIndex: number | undefined }) {
  return compact(getMultilegLegMarketDetails(params).map(market => market.MarketAccount));
}

export function getMultilegLegMarkets(params: { dataSecurity: Security; legIndex: number | undefined }) {
  return compact(getMultilegLegMarketDetails(params).map(market => market.Market));
}
